// Lightweight static background with CSS-only animations for better performance
const ParticleBackground = ({ density = 50, opacity = 0.1 }) => {
  // Convert to pure CSS implementation - no React state or effects needed
  const dotCount = Math.min(density / 10, 8); // Drastically reduce number of elements
  
  return (
    <div
      className="absolute inset-0 overflow-hidden pointer-events-none particle-background"
      style={{ zIndex: -1 }}
    >
      {/* Static gradient orbs instead of animated particles */}
      <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-teal-500/5 rounded-full blur-xl" />
      <div className="absolute top-1/3 right-1/4 w-24 h-24 bg-indigo-500/5 rounded-full blur-lg" />
      <div className="absolute bottom-1/3 left-1/3 w-28 h-28 bg-purple-500/5 rounded-full blur-xl" />
      <div className="absolute bottom-1/4 right-1/3 w-20 h-20 bg-cyan-500/5 rounded-full blur-lg" />
      
      {/* Minimal floating dots with CSS animation - only on desktop */}
      <div className="hidden md:block">
        {Array.from({ length: dotCount }, (_, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 bg-teal-400/20 rounded-full floating-slow"
            style={{
              left: `${20 + (i * 10)}%`,
              top: `${30 + (i * 5)}%`,
              animationDelay: `${i * 0.5}s`
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ParticleBackground;
